"use strict";
var Observable_1 = require('../../Observable');
var interval_1 = require('../../observable/interval');
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/rxjs/add/observable/interval.js
// module id = ACG2
// module chunks = 6